import styled from "@emotion/styled";
import { fontBarlowSemiCondensed, fontPlayfairDisplay, fontRoboto } from "@product/scmp-sdk";

export const RootContainer = styled.div`
  display: flex;
  gap: 10px;

  inline-size: 100%;
  padding-block: 20px;

  border-block-start: 1px solid #e0e0e0;
  border-block-end: 1px solid #e0e0e0;

  ${props => props.theme.breakpoints.up("tablet")} {
    gap: 24px;
  }
`;

export const LeftContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  inline-size: 100%;
`;

export const RightContainer = styled.div`
  display: flex;
`;

export const ImageContainer = styled.div`
  inline-size: 100px;
  margin: auto;

  aspect-ratio: 1/1;

  ${props => props.theme.breakpoints.up("tablet")} {
    inline-size: 180px;
  }
  ${props => props.theme.breakpoints.up("desktop")} {
    inline-size: 220px;
  }
`;

export const Topic = styled.span`
  min-block-size: 14px;

  color: #222222;
  font-weight: 500;
  font-size: 12px;
  font-family: ${fontBarlowSemiCondensed};
  line-height: normal;
  letter-spacing: 1.2px;
  text-transform: uppercase;
`;

export const TitleContainer = styled.div`
  margin-block-start: 8px;
`;

export const Title = styled.span`
  color: #000000;
  font-weight: 400;
  font-size: 20px;
  font-family: ${fontPlayfairDisplay};
  line-height: 26px;

  &:hover {
    border-block-end: 1px solid #222222;
  }
`;

export const UpdatedDateContainer = styled.div`
  margin-block-start: 8px;

  color: #aaaaaa;
  font-weight: 400;
  font-size: 12px;
  font-family: ${fontRoboto};
  line-height: 14px;
`;
